import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataWpServiceServAdic, DataWpServiceServAdicPadre } from '../data-wp.service';
import { PostI } from '../post.interface';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgwWowService } from 'ngx-wow';
import { Observable  } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-servicios-adicionales',
  templateUrl: './servicios-adicionales.component.html',
  styleUrls: ['./servicios-adicionales.component.css'],
  providers: [DataWpServiceServAdic, DataWpServiceServAdicPadre],
  encapsulation: ViewEncapsulation.None
})
export class ServiciosAdicionalesComponent implements OnInit {
  product
  title
  posts$: Observable<PostI[]>;

  posts: PostI[];
  postsPadre: PostI[];

  constructor( 
    private postsService: DataWpServiceServAdic, 
    private postsServicePadre: DataWpServiceServAdicPadre, 
    private router: Router,  
    private wowService: NgwWowService,
    private titleService: Title, 
    private metaService: Meta
    ) {
    this.wowService.init();
   }
  ngOnInit() {
    /* PADRE SERVICIOS ADIC */
    this.postsServicePadre.getPosts().subscribe( 
      (postsPadre: PostI[]) => this.postsPadre = postsPadre, 
      (err: HttpErrorResponse) => err.error instanceof Error ? console.log('An error occurred:', err.error.message) : console.log(`Backend returned code ${err.status}, body was: ${err.error}`));

    /* HIJOS SERVICIOS ADIC */
    this.postsService.getPosts().subscribe( 
      (posts: PostI[]) => {this.posts = posts, console.log(posts);
      }, 
      (err: HttpErrorResponse) => err.error instanceof Error ? console.log('An error occurred:', err.error.message) : console.log(`Backend returned code ${err.status}, body was: ${err.error}`));
    
      this.posts$ = this.postsServicePadre.getPosts();
      this.posts$.subscribe(data => { 
        /*Levantamos MetaTags*/
        var titleSeo = this.product=data[0].acf.seo.titulo;
        var descripcionSeo = this.product=data[0].acf.seo.descripcion;
        var keywordsSeo = this.product=data[0].acf.seo.keywords;
        /*Seteamos Metatags en header*/
        this.titleService.setTitle( 'Vittal - ' + titleSeo );
        this.metaService.updateTag( {name: 'description', content: descripcionSeo} );
        this.metaService.updateTag( {name: 'keywords', content: keywordsSeo} );
        this.metaService.updateTag( {name: 'robots', content: 'index, follow'} );
       } 
      )

  }
  selectPost(slug) {
  	this.router.navigate([slug]);
  }

}
